import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useOutsideClick from 'utils/useOutsideClick';

const UpdatePatientStatusModal = ({
  togglePopup,
  handleClick,
  statusOptions,
}) => {
  const ref = useRef();
  useOutsideClick(ref, () => togglePopup(false));

  return (
    <div className="patient-status__modal" ref={ref}>
      {statusOptions.map(({ value, label }) => (
        <div
          className="patient-status__modal-item"
          key={value}
          onClick={() => {
            handleClick(value);
            togglePopup(false);
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

UpdatePatientStatusModal.propTypes = {
  togglePopup: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  statusOptions: PropTypes.object,
};

export default UpdatePatientStatusModal;
